import { jsx } from "react/jsx-runtime";
import { PageRuntimeProvider } from "../context/page-runtime.client.js";
import { PageSectionLayout } from "./PageSectionLayout.js";
const RenderPageStructure = ({ context, page }) => /* @__PURE__ */ jsx(PageRuntimeProvider, { value: context.getPageContext(), children: page.items?.map((layoutSection, layoutSectionIndex) => /* @__PURE__ */ jsx(
  PageSectionLayout,
  {
    ctx: context,
    layout: layoutSection
  },
  `${layoutSection.as ?? "section"}-${layoutSectionIndex}`
)) });
export {
  RenderPageStructure
};
//# sourceMappingURL=RenderPageStructure.js.map
